import { debugLog } from "../Utils/LogUtils";
import { useEffect } from "react";
import { provinceShortName } from "../Utils/PlanUtils";
import { shouldDisplayProvincialGrantOption } from "../Utils/PlanUtils";
import { useAuthenticationStatus } from "../Authentication/AuthenticationStatusProvider";

export default function useApplyNewAgentToEnrolment(state) {
  const { authenticationStatus } = useAuthenticationStatus();

  //When an agent is selected
  useEffect(() => {
    if (!state.enrollment.state) {
      return;
    }
    if (!state.agent.code) {
      return;
    }
    const applyAgentValues = (agentCode) => {
      const agent = authenticationStatus.user.agentCodes.find(
        (ac) => ac.code === agentCode,
      );

      if (agent === undefined) {
        state.setCommon({
          ...state.common,
          signingProvince: "unknown",
          agentCode: agentCode,
          agentName: `unknown`,
        });

        state.setAgent({
          ...state.agent,
          firstName: "unknown",
          lastName: "unknown",
          province: "unknown",
          code: agentCode,
          email: "unknown",
        });

        return;
      }

      state.setCommon({
        ...state.common,
        signingProvince: provinceShortName(agent.province),
        agentCode: agentCode,
        agentName: `${agent.firstName} ${agent.lastName}`,
      });

      state.setAgent({
        ...state.agent,
        firstName: agent.firstName,
        lastName: agent.lastName,
        province: provinceShortName(agent.province),
        code: agentCode,
        email: agent.email,
      });

      //If we have not yet set the subscriber province, we can default the subscriber's province
      if (!state.subscriber.province || !state.beneficiary.birthdate) {
        // && !state.beneficiary.birthdate) {
        state.setSubscriber((prevState) => {
          return {
            ...prevState,
            province: provinceShortName(agent.province),
          };
        });
      }
    };

    //Applied agent values to other parts of the state, as was done in the iPad
    applyAgentValues(state.agent.code);

    /*
        //We turn the provincial grant option on by default for SK and PQ (or wherever they are allowed)
        state.setApplication({
            ...state.application,
            grantProvincial: shouldDisplayProvincialGrantOption(state)
        });

         */

    /*
        if (state.subscriber.province !== state.common.signingProvince) {
            setProvinceError(t(`Your DR Code ${state.agent.code} is not licensed in the province ${state.subscriber.province}`));
        }
         */
    debugLog("useApplyNewAgentToEnrolment.js");
  }, [state.agent.code]);
}
